import qs from "qs";
import { IFeeType } from "../../types/Fees";
import authAxios, { authHeader } from "../data";

const fetchAll = async (req: any) => {
  const response = await authAxios.get("/api/FeeTypes", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return response.data;
};

const fetchCount = async () => {
  const response = await authAxios.get("/api/FeeTypes/Count", {
    headers: authHeader(),
  });

  return response.data;
};

const fetch = async (req: any) => {
  const response = await authAxios.get("/api/FeeTypes/" + req.id, {
    headers: authHeader(),
  });

  return response.data;
};

const create = async (entry: IFeeType) => {
  const response = await authAxios.post("/api/FeeTypes/", entry, {
    headers: authHeader(),
  });

  return response.data;
};

const edit = async (entry: IFeeType, id: string) => {
  const response = await authAxios.put("/api/FeeTypes/" + id, entry, {
    headers: authHeader(),
  });

  return response.data;
};

const deleteFee = async (req: any) => {
  const response = await authAxios.delete("/api/FeeTypes/" + req.id, {
    headers: authHeader(),
  });

  return response.data;
};

const FeesService = {
  fetchAll,
  fetchCount,
  fetch,
  create,
  edit,
  deleteFee,
};

export default FeesService;
